import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-combo-default',
  templateUrl: './combo-default.component.html',
  styleUrls: ['./combo-default.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboDefaultComponent),
      multi: true
    }]
})
export class ComboDefaultComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() mensaje_error: string;
  @Input() mensaje_ayuda: string;
  @Input("descripcion_etiqueta") descripcion_etiqueta: string = "Seleccione opción";
  @Input("combo_placeholder") combo_placeholder: string = "Seleccione...";
  @Input("opciones") opciones: { value: string, texto: string }[];

  modelValue: string = "";
  @Output("modelValueChange") modelValueChange: EventEmitter<string> = new EventEmitter<string>();

  private onChange = (value: string) => { };
  private onTouched = () => { };

  writeValue(value: string): void {
    this.modelValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: string): void {
    this.modelValue = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.onChange(value);
  }

  // onInputChange(value: string) {
  //   this.model_value = value;
  //   this.modelValueChange.emit(this.model_value);
  // }

}
